"use client";

import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

export interface SegmentedControlOption {
  value: string;
  label: string;
}

export interface SegmentedControlProps {
  options: SegmentedControlOption[];
  value: string;
  onChange: (value: string) => void;
  ariaLabel?: string;
  disabled?: boolean;
}

export default function SegmentedControl({
  options,
  value,
  onChange,
  ariaLabel,
  disabled = false,
}: SegmentedControlProps) {
  const groupLabel = ariaLabel ?? options.map((o) => o.label).join(", ");

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={(_e, newValue) => {
        if (newValue !== null) onChange(newValue);
      }}
      role="radiogroup"
      aria-label={groupLabel}
      aria-disabled={disabled || undefined}
      disabled={disabled}
      className="segmented-control"
    >
      {options.map((option) => {
        const isSelected = option.value === value;
        return (
          <ToggleButton
            key={option.value}
            value={option.value}
            role="radio"
            aria-checked={isSelected}
            tabIndex={isSelected ? 0 : -1}
          >
            {option.label}
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
}

